import { NumberFormatter } from "@mantine/core";

export default function FileSize({ size }) {
  let suffix = "B";
  let sizeNum = +size;
  if (sizeNum > 1024) {
    sizeNum /= 1024;
    suffix = "kB";
  }
  if (sizeNum > 1024) {
    sizeNum /= 1024;
    suffix = "MB";
  }
  if (sizeNum > 1024) {
    sizeNum /= 1024;
    suffix = "GB";
  }

  return (
    <NumberFormatter
      suffix={"\u00A0" + suffix}
      value={sizeNum}
      decimalScale={1}
    />
  );
}
